<template lang="pug">
  app-toolbar(title="АДВОКАТЫ / заявки на оплату")
    app-toolbar-item(label="Показать" :items="preparedStatuses" key-name="title" min-width="216" @select="filterByStatus") {{ selectedStatus | statusNamed }}
      template(slot="list-item" slot-scope="{ item, index }" ) 
        span.sud-case-status-color(v-bind:style="{ background: statusColor(item) }")
        span.sud-case-filter.text-lowercase {{ item.title }}
    app-toolbar-item.ml-12(label="Судья" :items="judges" all="Все" @select="filterByJudge") {{ selectedJudge | judgeNamed }}
        template(slot="list-item" slot-scope="{ item, index }") 
          | {{ item | judgeNamed }}


    app-toolbar-item-period.ml-12(@select="setPeriod") {{ period ? period.text : 'все' }} 

    app-dialog-loading(v-model="updating")
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { $_app_moment } from "@/common/AppMoment.js"
import AppStatuses from "@/assets/data/SpecAppStatuses.json"

import { AppDialogLoading } from '@/components'

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogLoading.name]: AppDialogLoading
  },
  mixins: [ $_app_moment ],
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapState('advocat', ['selectedStatus', 'selectedJudge', 'period', 'startPeriod', 'endPeriod', 'updating']),
    ...mapGetters('advocat', ['statuses', 'isStatusesLoaded', 'judges','isJudgesLoaded']),
    preparedStatuses () {
      let lastColor = 0
      let list = []

      for (let index = 0; index < this.statuses.length; index++) {
        const element = this.statuses[index]
        if (index==0) list.push({ title: 'Все', color: 0 })

        if (lastColor != 0 && lastColor != element.color) {
          list.push({ divider: true })
        }
        lastColor = element.color
        list.push(element)
      }
      return list
    }
  },

  methods: {
    ...mapMutations('advocat', ['setAppsStatus', 'setStatuses', 'selectStatus', 'selectJudge', 'setPeriod', 'setTypePeriod']),

    statusColor(item) {
      if (item.color > 0 && item.color < 4) {
        return AppStatuses.colors[item.color]
      }
      return ''
    },

    filterByStatus(status) {
      if (status.color!=0) 
        this.selectStatus(status)
      else 
        this.selectStatus(null)
    },

    filterByJudge(judge) {
      this.selectJudge(judge)
    }
  },

  filters: {
    statusNamed: status => {
      return status != null ? status.title : 'Все'
    },

    judgeNamed: judge => {
      return judge!=null ? judge.lastName+" "+judge.firstName+" "+judge.middleName : 'Все'
    }
  },

}
</script>


<style lang="scss" scoped>
.sud-card-text {
  background: #FFFFFF; 
}

.sud-case-status-color {
  margin: 0 16px 0 0;
}


</style>
